import { render, staticRenderFns } from "./sourceEdit.vue?vue&type=template&id=76564d84&scoped=true&"
import script from "./sourceEdit.vue?vue&type=script&lang=js&"
export * from "./sourceEdit.vue?vue&type=script&lang=js&"
import style0 from "./sourceEdit.vue?vue&type=style&index=0&id=76564d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76564d84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76564d84')) {
      api.createRecord('76564d84', component.options)
    } else {
      api.reload('76564d84', component.options)
    }
    module.hot.accept("./sourceEdit.vue?vue&type=template&id=76564d84&scoped=true&", function () {
      api.rerender('76564d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/manage/components/sourceEdit.vue"
export default component.exports